var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_2277)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 10.3906,
    fill: "#23C983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8243 7.67948C17.59 7.44017 17.2101 7.44017 16.9757 7.67948L9.78737 15.0208L7.02428 12.1989C6.78997 11.9596 6.4101 11.9597 6.17575 12.1989C5.94142 12.4382 5.94142 12.8262 6.17575 13.0655L9.3631 16.3206C9.59734 16.5599 9.97749 16.5597 10.2116 16.3206L17.8243 8.54606C18.0586 8.30677 18.0586 7.9188 17.8243 7.67948Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_2277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8892ff2afbff40966e13b616a80fb692.svg";
export { ForwardRef as ReactComponent };